import { render, staticRenderFns } from "./CodeCard.vue?vue&type=template&id=4cd920fe&scoped=true"
import script from "./CodeCard.vue?vue&type=script&lang=js"
export * from "./CodeCard.vue?vue&type=script&lang=js"
import style0 from "./CodeCard.vue?vue&type=style&index=0&id=4cd920fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd920fe",
  null
  
)

export default component.exports